class DiscountAppointmentTimer {
    constructor(element) {
        this.element = element
        this.counter = $(this.element).find('.js-discount-appointment-counter')
        this.units = $(this.element).find('.js-discount-appointment-units')
        this.seconds = +$(this.element).data('timer-seconds') || 0
        this.timer = null
    }

    start() {
        this.setTime()
        this.changeTimerValues(calculateDate(this.seconds))
        this.timer = startTimer(this.seconds, this.changeTimerValues.bind(this), () => $(this.element).trigger('timer:end'))
    }

    setTime() {
        const { time, endTime } = this.times
        if (!endTime || endTime > time) {
            localStorage.setItem('endTime', String(time))
        } else {
            this.seconds = endTime
        }
    }

     changeTimerValues(data) {
        const dayTime = data.time.days < 100 ? ('0' + data.time.days).slice(-2) : data.time.days
        this.setTimerText('day', dayTime, data.dataSet.days || 'дней')
        this.setTimerText('hour', ('0' + data.time.hours).slice(-2), data.dataSet.hours || 'часов')
        this.setTimerText('minute', ('0' + data.time.minutes).slice(-2), data.dataSet.minutes || 'минут')
        this.setTimerText('second', ('0' + data.time.seconds).slice(-2), data.dataSet.seconds || 'секунд')
     }

    setTimerText(unit, time, text) {
        this.counter.find(`[data-timer-counter='${unit}']`).text(time)
        this.units.find(`[data-timer-unit='${unit}']`).text(text)
    }

    clear() {
        clearTimeout(this.timer)
        localStorage.removeItem('endTime')
    }

    get times() {
        const time = new Date().setSeconds(new Date().getSeconds() + this.seconds)
        let endTime = 0
        const currentEndTime = +localStorage.getItem('endTime') || 0
        if (Number.isSafeInteger(currentEndTime)  && currentEndTime > 0) {
            endTime = (currentEndTime - new Date().getTime()) / 1000
        }
        return { time, endTime }
    }
}
